<mat-spinner *ngIf="loading"></mat-spinner>
<div *transloco="let t">
    <div class="title">{{t('download-reports')}}</div>
    <app-download-report-item *ngFor="let report of reportData" [itemData]="report" [hidden]="!report.display" (loading)="loadingEvent($event)" [disableButton]="loading"></app-download-report-item>
</div>
